import { AppThunk } from "..";
import { Language, setLanguage } from "./language-slice";

export const changeLanguage = (value: Language): AppThunk => async (
  dispatch
) => {
  dispatch(setLanguage(value));
};
